import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { createChargeSummaryReportApi } from "./api";
import { ChargeSummaryReportReduxTypes } from "./types";

function* createChargeSummaryReportSaga(action:any):Generator {
    try {
        const response: any = yield call(createChargeSummaryReportApi, action.payload);
        yield put({
            type: ChargeSummaryReportReduxTypes.CHARGE_SUMMARY_REPORT_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: ChargeSummaryReportReduxTypes.CHARGE_SUMMARY_REPORT_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchCreateChargeSummaryReport(): SagaIterator {
    yield takeEvery(ChargeSummaryReportReduxTypes.CHARGE_SUMMARY_REPORT, createChargeSummaryReportSaga);
}

function* chargeSummaryReportSaga(): SagaIterator {
    yield all([fork(watchCreateChargeSummaryReport)]);
}

export default chargeSummaryReportSaga;  